export const getUserState = (user) => {
  const noUserData = Object.keys(user || {}).length === 0;

  if (noUserData || user.error) return "anonymous";
  if (user.free_account) return "free_account";
  if (!user.free_account) return "paid_account";

  throw new Error("User state not found");
};
